import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-item-list-panel" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "p-item-list-panel__img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-item-list-panel__content" }
const _hoisted_6 = { class: "p-item-list-panel__name__text" }
const _hoisted_7 = { class: "p-item-list-panel__point" }
const _hoisted_8 = { class: "p-item-list-panel__point__unit" }
const _hoisted_9 = {
  key: 0,
  class: "p-item-list-panel__discount_rate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleMedium = _resolveComponent("TitleMedium")!
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("a", {
      href: '/product-details/?id=' + _ctx.id,
      class: "p-item-list-panel__link",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.viewProductDetails(_ctx.id)), ["prevent","stop"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.imgPath,
          alt: "商品画像",
          class: "p-item-list-panel__img",
          style: _normalizeStyle(_ctx.setOpacity)
        }, null, 12, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["p-item-list-panel__name", { is_ie: _ctx.isIe }])
        }, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.name), 1)
        ], 2),
        _createElementVNode("p", _hoisted_7, [
          _createVNode(_component_TitleMedium, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.addComma(_ctx.point)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.unit), 1)
        ]),
        (_ctx.discountRate)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " (" + _toDisplayString(_ctx.discountRate) + "%OFF) ", 1))
          : _createCommentVNode("", true),
        (_ctx.status)
          ? (_openBlock(), _createBlock(_component_TextLabel, {
              key: 1,
              color: { border: _ctx.color, content: '#fff' },
              reverse: true,
              class: "p-item-list-panel__status"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.status), 1)
              ]),
              _: 1
            }, 8, ["color"]))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_2)), [
      [_directive_touch, void 0, "tap"]
    ])
  ]))
}